/* All Cash Baby: two native contact submissions, one scoped controller. */
(function () {
  'use strict';
  const BUILD = 'acb-flow-20261025-v2';
  const MAX_AGE = 2 * 60 * 60 * 1000;
  const money = value => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0
  }).format(value);
  const number = value => {
    const clean = String(value || '').replace(/[$,\s]/g, '');
    return /^\d+(\.\d{1,2})?$/.test(clean) ? Number(clean) : NaN;
  };
  function reference() {
    return 'ACB-' + Date.now().toString(36).toUpperCase() + '-' +
      Math.random().toString(36).slice(2, 7).toUpperCase();
  }
  function mapsReady(key) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) return Promise.resolve();
    if (window.acbMapsV2) return window.acbMapsV2;
    window.acbMapsV2 = new Promise((resolve, reject) => {
      let polling;
      const timeout = setTimeout(() => {
        clearInterval(polling);
        reject(new Error('Address suggestions unavailable.'));
      }, 15000);
      const ready = () => { clearTimeout(timeout); clearInterval(polling); resolve(); };
      if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
        polling = setInterval(() => {
          if (window.google && window.google.maps && window.google.maps.importLibrary) ready();
        }, 100);
      } else {
        window.acbMapsReadyV2 = ready;
        const script = document.createElement('script');
        const url = new URL('https://maps.googleapis.com/maps/api/js');
        Object.entries({ key: key, loading: 'async', v: 'weekly', libraries: 'places',
          callback: 'acbMapsReadyV2' }).forEach(([name, value]) => url.searchParams.set(name, value));
        script.src = url.toString();
        script.async = true;
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Address suggestions unavailable.')); };
        document.head.appendChild(script);
      }
    });
    return window.acbMapsV2;
  }
  function calendarReady() {
    if (window.Calendly && window.Calendly.initPopupWidget) return Promise.resolve();
    if (window.acbCalendarV2) return window.acbCalendarV2;
    window.acbCalendarV2 = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://calendly.com/assets/external/widget.css';
      document.head.appendChild(css);
      const script = document.createElement('script');
      script.src = 'https://calendly.com/assets/external/widget.js';
      script.async = true;
      const timeout = setTimeout(() => reject(new Error('Calendar could not load.')), 15000);
      script.onload = () => {
        clearTimeout(timeout);
        if (window.Calendly && window.Calendly.initPopupWidget) resolve();
        else reject(new Error('Calendar could not load.'));
      };
      script.onerror = () => { clearTimeout(timeout); reject(new Error('Calendar could not load.')); };
      document.head.appendChild(script);
    });
    return window.acbCalendarV2;
  }
  function init(root) {
    if (root.dataset.acbInitialized === BUILD) return;
    const find = name => root.querySelector('[data-acb="' + name + '"]');
    const firstForm = find('address-form');
    const fullForm = find('details-form');
    if (!firstForm || !fullForm) return;
    root.dataset.acbInitialized = BUILD;
    const storageKey = 'acbFlowV2:' + root.dataset.sectionId;
    const field = name => fullForm.querySelector('[data-field="' + name + '"]');
    const value = name => field(name).value.trim();
    const response = stage => root.querySelector('[data-response="' + stage + '"]');
    let state = { version: 2, ref: reference(), at: Date.now(), step: 'address',
      address: '', details: {}, pending: null, result: null };
    let storageAvailable = true;
    let formSending = false;
    const current = new URL(window.location.href);
    try {
      if (current.searchParams.get('acb_new') === '1') sessionStorage.removeItem(storageKey);
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && saved.version === 2 && Date.now() - saved.at < MAX_AGE &&
          ['address', 'details'].includes(saved.step) && saved.ref &&
          saved.details && typeof saved.details === 'object') state = saved;
    } catch (error) { storageAvailable = false; }
    function save() {
      state.at = Date.now();
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); return true; }
      catch (error) { storageAvailable = false; return false; }
    }
    function status(text, isError) {
      const box = find('status');
      box.textContent = text || '';
      box.hidden = !text;
      box.classList.toggle('acb-error', !!isError);
    }
    function details() {
      const tenant = fullForm.querySelector('input[data-field="tenant"]:checked');
      return { first: value('first'), last: value('last'), email: value('email'),
        phone: value('phone'), address: value('address'), arv: value('arv'),
        tenant: tenant ? tenant.value : 'No' };
    }
    function prepareAddress() {
      const selected = find('address-input').value.trim();
      firstForm.querySelector('[name="contact[Inquiry reference]"]').value = state.ref;
      firstForm.querySelector('[name="contact[body]"]').value = [
        'NEW PROPERTY ADDRESS - ALL CASH BABY', '',
        'Inquiry reference: ' + state.ref,
        'Property Address: ' + selected, '',
        'Visitor clicked GET STARTED. Contact details have not yet been provided.',
        'The email field is the internal notification address, not the visitor email.'
      ].join('\n');
      if (state.step === 'address') state.address = selected;
      save();
      return selected;
    }
    function prepareDetails(formData) {
      const d = details();
      const arv = number(d.arv);
      const validAmount = Number.isFinite(arv) && arv > 0;
      const deduction = d.tenant === 'Yes' ? 25000 : 0;
      const offer = validAmount ? Math.max(0, arv * 0.65 - deduction) : null;
      const summary = [
        'FULL PROPERTY INQUIRY - ALL CASH BABY', '',
        'Inquiry reference: ' + state.ref,
        'First Name: ' + d.first, 'Last Name: ' + d.last,
        'Email: ' + d.email, 'Phone: ' + d.phone,
        'Property Address: ' + d.address,
        'Estimated Remodeled Value: ' + (validAmount ? money(arv) : d.arv),
        'Tenant Issues / Uncooperative Tenants: ' + d.tenant,
        'Tenant Deduction: ' + money(deduction),
        'Estimated Cash Offer: ' + (offer !== null ? money(offer) : ''), '',
        'Estimate only; not a binding offer or guarantee to purchase.'
      ].join('\n');
      const derived = {
        'contact[name]': (d.first + ' ' + d.last).trim(),
        'contact[Inquiry reference]': state.ref,
        'contact[Estimated Cash Offer]': offer !== null ? money(offer) : '',
        'contact[Tenant deduction]': money(deduction),
        'contact[body]': summary
      };
      Object.entries(derived).forEach(([name, content]) => {
        const input = fullForm.elements.namedItem(name);
        if (input) input.value = content;
        if (formData) formData.set(name, content);
      });
      state.details = d;
      if (state.step !== 'address') state.address = d.address;
      save();
      return { details: d, arv: arv, offer: offer, validAmount: validAmount };
    }
    function bookingURL(d) {
      const url = new URL(root.dataset.calendlyUrl);
      const digits = d.phone.replace(/\D/g, '');
      const local = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
      const phone = local.length === 10
        ? '(' + local.slice(0, 3) + ') ' + local.slice(3, 6) + '-' + local.slice(6)
        : d.phone;
      const cap = text => text ? text[0].toUpperCase() + text.slice(1) : '';
      url.searchParams.set('name', (cap(d.first) + ' ' + cap(d.last)).trim());
      url.searchParams.set('email', d.email);
      url.searchParams.set('a1', d.address);
      url.searchParams.set('a2', phone);
      return url.toString().replace(/\+/g, '%20');
    }
    function showStep() {
      const step = state.step;
      find('step-address').hidden = step !== 'address';
      find('step-details').hidden = step !== 'details';
      find('step-result').hidden = step !== 'result';
      find('progress').textContent = step === 'address' ? 'STEP 1 OF 3 - YOUR PROPERTY'
        : step === 'details' ? 'STEP 2 OF 3 - YOUR DETAILS' : 'STEP 3 OF 3 - YOUR ESTIMATE';
      if (step === 'result' && state.result && state.result.accepted === true) {
        find('offer').textContent = money(state.result.offer);
        find('reference').textContent = state.ref;
        find('booking').href = bookingURL(state.result.details);
      }
    }
    if (state.pending) {
      const stage = state.pending.stage;
      const reply = response(stage);
      const success = reply && reply.dataset.accepted === 'true' && reply.dataset.errors !== 'true';
      if (success && current.searchParams.get('contact_posted') === 'true') {
        if (stage === 'address') {
          state.step = 'details';
          state.details.address = state.address;
          status('Your property address was submitted. Please complete your details below.');
        } else if (stage === 'details' && state.pending.snapshot) {
          state.result = Object.assign({}, state.pending.snapshot, { accepted: true });
          state.step = 'result';
          status('Your full property inquiry was submitted. Your estimate is shown below.');
        }
      } else {
        state.step = stage === 'details' ? 'details' : 'address';
        status('This submission was not confirmed. Please review your details and any verification message before trying again.', true);
      }
      state.pending = null;
      save();
    }
    if (state.step === 'result' && (!state.result || !state.result.accepted)) state.step = 'details';
    find('address-input').value = state.address || '';
    ['first', 'last', 'email', 'phone', 'address', 'arv'].forEach(name => {
      field(name).value = state.details[name] || (name === 'address' ? state.address : '') || '';
    });
    fullForm.querySelectorAll('[data-field="tenant"]').forEach(input => {
      input.checked = input.value === (state.details.tenant || 'No');
    });
    prepareAddress();
    prepareDetails();
    current.searchParams.delete('contact_posted');
    current.searchParams.delete('acb_new');
    current.searchParams.delete('acb_address_return');
    try { history.replaceState(history.state, '', current.pathname + current.search + current.hash); }
    catch (error) { /* History access is optional. */ }
    showStep();
    if (!storageAvailable) status('Please allow website storage to keep your address between steps.', true);
    find('address-input').addEventListener('input', prepareAddress);
    fullForm.addEventListener('input', () => prepareDetails(), true);
    fullForm.addEventListener('change', () => prepareDetails(), true);
    fullForm.addEventListener('focusout', () => prepareDetails(), true);
    field('arv').addEventListener('blur', () => {
      const amount = number(value('arv'));
      if (Number.isFinite(amount) && amount > 0) field('arv').value = amount.toLocaleString('en-US');
      prepareDetails();
    });
    find('next').addEventListener('click', event => {
      const selected = prepareAddress();
      if (!selected || !firstForm.checkValidity()) return;
      state.pending = { stage: 'address', at: Date.now() };
      state.result = null;
      if (!save()) { event.preventDefault(); state.pending = null; status('Please allow website storage before continuing.', true); }
    }, true);
    find('submit').addEventListener('click', event => {
      const prepared = prepareDetails();
      if (!prepared.validAmount || !fullForm.checkValidity()) return;
      state.pending = { stage: 'details', at: Date.now(), snapshot: prepared };
      if (!save()) { event.preventDefault(); state.pending = null; status('Please allow website storage before submitting.', true); }
    }, true);
    fullForm.addEventListener('formdata', event => prepareDetails(event.formData));
    firstForm.addEventListener('submit', event => {
      if (window.Shopify && window.Shopify.designMode) {
        event.preventDefault(); status('Open Preview store in a separate tab to test this form.', true); return;
      }
      const selected = prepareAddress();
      if (!selected) {
        event.preventDefault(); status('Please select or enter the full property address.', true); return;
      }
      state.pending = { stage: 'address', at: Date.now() };
      state.result = null;
      if (!save()) {
        event.preventDefault(); state.pending = null;
        status('Please allow website storage before continuing.', true); return;
      }
      formSending = true;
      status('Submitting your address. Complete verification if Shopify asks.');
    });
    fullForm.addEventListener('submit', event => {
      const prepared = prepareDetails();
      if (!prepared.validAmount) {
        event.preventDefault(); status('Please enter a valid remodeled value greater than zero.', true);
        field('arv').focus(); return;
      }
      if (window.Shopify && window.Shopify.designMode) {
        event.preventDefault(); status('Open Preview store in a separate tab to test this form.', true); return;
      }
      state.pending = { stage: 'details', at: Date.now(), snapshot: prepared };
      if (!save()) {
        event.preventDefault(); state.pending = null;
        status('Please allow website storage before submitting.', true); return;
      }
      formSending = true;
      status('Submitting your complete property inquiry. Complete verification if Shopify asks.');
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted && formSending) {
        formSending = false;
        status('You returned to the form. Check your submission before sending it again.');
      }
    });
    root.querySelectorAll('[data-acb="restart"]').forEach(button => {
      button.addEventListener('click', () => {
        try { sessionStorage.removeItem(storageKey); } catch (error) {}
        const url = new URL(window.location.href);
        ['contact_posted', 'acb_address_return'].forEach(key => url.searchParams.delete(key));
        url.searchParams.set('acb_new', '1');
        url.hash = root.id;
        window.location.assign(url.toString());
      });
    });
    find('booking').addEventListener('click', async event => {
      event.preventDefault();
      if (!state.result || !state.result.accepted) return;
      const url = bookingURL(state.result.details);
      status('Opening the appointment calendar...');
      try {
        await calendarReady();
        window.Calendly.initPopupWidget({ url: url });
        status('');
      } catch (error) {
        status('The calendar could not open. Please use the direct booking link below.', true);
        find('booking-fallback').href = url;
        find('booking-fallback').hidden = false;
      }
    });
    let manual = false;
    let selection = 0;
    function manualEntry() {
      manual = true;
      find('autocomplete').hidden = true;
      find('address-input').type = 'text';
      find('address-input').required = true;
      find('manual').hidden = true;
      find('selected').hidden = true;
    }
    find('manual').addEventListener('click', () => {
      manualEntry(); find('address-input').focus();
    });
    if (state.step === 'address') mapsReady(root.dataset.googleKey).then(async () => {
      const places = await window.google.maps.importLibrary('places');
      if (manual || !root.isConnected) return;
      const autocomplete = new places.PlaceAutocompleteElement({ includedRegionCodes: ['us'] });
      autocomplete.setAttribute('placeholder', 'Start typing the property address');
      autocomplete.setAttribute('aria-label', 'Property address');
      find('autocomplete').appendChild(autocomplete);
      find('autocomplete').hidden = false;
      find('address-input').type = 'hidden';
      find('address-input').required = false;
      find('manual').hidden = false;
      if (state.address) {
        find('selected').textContent = state.address;
        find('selected').hidden = false;
      }
      autocomplete.addEventListener('input', () => {
        selection += 1;
        find('address-input').value = '';
        find('selected').hidden = true;
        prepareAddress();
      });
      autocomplete.addEventListener('gmp-select', async event => {
        const revision = ++selection;
        try {
          const place = event.placePrediction.toPlace();
          await place.fetchFields({ fields: ['formattedAddress'] });
          if (revision !== selection || manual) return;
          find('address-input').value = place.formattedAddress || '';
          find('selected').textContent = find('address-input').value;
          find('selected').hidden = !find('address-input').value;
          prepareAddress();
          status('');
        } catch (error) { manualEntry(); status('Please type the full property address below.', true); }
      });
      autocomplete.addEventListener('gmp-error', manualEntry);
    }).catch(() => { manualEntry(); });
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-acb-flow]')) init(scope);
    scope.querySelectorAll('[data-acb-flow]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  function attachClose() {
    document.querySelectorAll('.calendly-overlay').forEach(overlay => {
      const popup = overlay.querySelector('.calendly-popup');
      const close = overlay.querySelector('.calendly-popup-close');
      if (popup && close && close.parentElement !== popup) popup.appendChild(close);
      if (close) close.setAttribute('aria-label', 'Continue to our site');
    });
  }
  if (!window.acbCalendarObserverV2) {
    window.acbCalendarObserverV2 = new MutationObserver(attachClose);
    window.acbCalendarObserverV2.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('message', event => {
      if (event.origin !== 'https://calendly.com' || !event.data ||
          event.data.event !== 'calendly.event_scheduled') return;
      document.querySelectorAll('.calendly-overlay').forEach(overlay => {
        const iframe = overlay.querySelector('iframe');
        if (iframe && event.source === iframe.contentWindow) overlay.classList.add('acb-booking-complete');
      });
    });
  }
})();
